module.exports = __webpack_public_path__ + "static/media/submenu-dispositivo.ebe9fb4b.svg";